var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B6BB"
    },
    d: "M432.784,229.809l-85.291-60.945c1.604,16.99,2.475,34.722,2.475,53.001 c0,1.408-0.102,2.748-0.12,4.147c-0.077,13.875-0.546,34.586-1.374,57.011l52.727,37.623c9.318,6.647,22.289,4.267,28.638-5.257 l14.609-21.914C458.375,272.587,453.213,244.41,432.784,229.809"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B6BB"
    },
    d: "M179.2,221.867c0-9.498,0.256-18.833,0.708-28.006c0.179-3.78,0.529-7.415,0.785-11.127 c0.324-4.634,0.555-9.344,0.981-13.867l-85.291,60.945c-20.429,14.601-25.591,42.778-11.665,63.667l14.609,21.914 c6.349,9.523,19.319,11.904,28.638,5.257l52.634-37.555C179.677,258.313,179.2,235.554,179.2,221.867"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D75A4A"
    },
    d: "M195.664,102.4H333.4c-5.734-17.161-12.962-33.835-21.649-49.792l-12.826-23.561 c-14.831-27.247-53.956-27.247-68.787,0l-12.826,23.561C208.626,68.565,201.407,85.239,195.664,102.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8EDEE"
    },
    d: "M346.973,164.458c-2.185-21.197-6.827-41.941-13.568-62.054H195.66 c-6.733,20.096-11.383,40.875-13.568,62.054c-1.886,18.304-2.893,37.547-2.893,57.412c0,24.226,1.502,76.877,4.267,118.903 c1.911,28.979,25.95,51.456,54.929,51.738c1.425-1.075,2.85-2.005,4.275-2.85c0.06,0.29,0.128,0.546,0.188,0.836 c-2.458-11.802-3.925-25.677-3.925-40.627c0-42.419,11.46-76.8,25.6-76.8s25.6,34.381,25.6,76.8c0,14.95-1.468,28.826-3.934,40.627 c0.068-0.299,0.145-0.563,0.205-0.862c1.732,0.99,3.115,1.954,4.318,2.867c28.962-0.307,52.966-22.767,54.878-51.729 c2.765-42.027,4.267-94.677,4.267-118.903C349.866,202.004,348.859,182.762,346.973,164.458"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D55B"
    },
    d: "M494.933,85.333c0,4.71-3.823,8.533-8.533,8.533s-8.533-3.823-8.533-8.533 c0-4.71,3.823-8.533,8.533-8.533S494.933,80.623,494.933,85.333"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D55B"
    },
    d: "M34.133,418.133c0,4.71-3.823,8.533-8.533,8.533s-8.533-3.823-8.533-8.533s3.823-8.533,8.533-8.533 S34.133,413.423,34.133,418.133"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D55B"
    },
    d: "M85.333,204.8c0,4.71-3.823,8.533-8.533,8.533c-4.71,0-8.533-3.823-8.533-8.533 c0-4.71,3.823-8.533,8.533-8.533C81.51,196.267,85.333,200.09,85.333,204.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D55B"
    },
    d: "M34.108,42.667c3.234,2.432,6.127,5.316,8.559,8.559c2.432-3.243,5.316-6.127,8.559-8.559 c-3.243-2.432-6.127-5.316-8.559-8.559C40.235,37.35,37.342,40.235,34.108,42.667 M42.667,85.333c-4.71,0-8.533-3.814-8.533-8.533 c0-14.114-11.486-25.6-25.6-25.6C3.823,51.2,0,47.386,0,42.667s3.823-8.533,8.533-8.533c14.114,0,25.6-11.486,25.6-25.6 C34.134,3.814,37.957,0,42.667,0S51.2,3.814,51.2,8.533c0,14.114,11.486,25.6,25.6,25.6c4.71,0,8.533,3.814,8.533,8.533 S81.511,51.2,76.8,51.2c-14.114,0-25.6,11.486-25.6,25.6C51.2,81.519,47.377,85.333,42.667,85.333"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D55B"
    },
    d: "M447.267,460.8l13.534,13.534l13.534-13.534L460.8,447.266L447.267,460.8z M460.8,498.466 L423.134,460.8l37.666-37.666l37.666,37.666L460.8,498.466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D55B"
    },
    d: "M460.8,443.733c-4.719,0-8.533-3.814-8.533-8.533v-17.067c0-4.719,3.814-8.533,8.533-8.533 c4.719,0,8.533,3.814,8.533,8.533V435.2C469.333,439.919,465.519,443.733,460.8,443.733"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D55B"
    },
    d: "M503.466,469.333H486.4c-4.719,0-8.533-3.814-8.533-8.533c0-4.719,3.814-8.533,8.533-8.533h17.067 c4.719,0,8.533,3.814,8.533,8.533C512,465.519,508.185,469.333,503.466,469.333"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D55B"
    },
    d: "M460.8,512c-4.719,0-8.533-3.814-8.533-8.533V486.4c0-4.719,3.814-8.533,8.533-8.533 c4.719,0,8.533,3.814,8.533,8.533v17.067C469.333,508.186,465.519,512,460.8,512"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D55B"
    },
    d: "M435.2,469.333h-17.067c-4.719,0-8.533-3.814-8.533-8.533c0-4.719,3.814-8.533,8.533-8.533H435.2 c4.719,0,8.533,3.814,8.533,8.533C443.733,465.519,439.919,469.333,435.2,469.333"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M128,238.933c0,4.71,3.823,8.533,8.533,8.533s8.533-3.823,8.533-8.533s-3.823-8.533-8.533-8.533 S128,234.223,128,238.933"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M102.4,256c0,4.71,3.823,8.533,8.533,8.533c4.71,0,8.533-3.823,8.533-8.533 c0-4.71-3.823-8.533-8.533-8.533C106.223,247.467,102.4,251.29,102.4,256"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M110.933,281.6c0,4.71,3.823,8.533,8.533,8.533c4.71,0,8.533-3.823,8.533-8.533 s-3.823-8.533-8.533-8.533C114.756,273.067,110.933,276.89,110.933,281.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M136.533,264.533c0,4.71,3.823,8.533,8.533,8.533c4.71,0,8.533-3.823,8.533-8.533 c0-4.71-3.823-8.533-8.533-8.533C140.356,256,136.533,259.823,136.533,264.533"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M375.466,264.533c0,4.71,3.823,8.533,8.533,8.533s8.533-3.823,8.533-8.533 c0-4.71-3.823-8.533-8.533-8.533S375.466,259.823,375.466,264.533"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B6BB"
    },
    d: "M290.133,349.867c0,42.419-11.46,76.8-25.6,76.8s-25.6-34.381-25.6-76.8s11.46-76.8,25.6-76.8 S290.133,307.447,290.133,349.867"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D55B"
    },
    d: "M294.847,396.126c0,0-2.884-3.319-8.439-6.485c-4.497,22.17-12.595,37.026-21.871,37.026 c-9.276,0-17.374-14.848-21.871-37.009c-2.807,1.673-5.666,3.686-8.448,6.468c-14.609,14.609-16.307,37.376-4.838,54.562 l35.157,52.779l35.157-52.642C311.154,433.63,309.456,410.735,294.847,396.126"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M401.169,238.933c0,4.71-3.823,8.533-8.533,8.533c-4.71,0-8.533-3.823-8.533-8.533 s3.823-8.533,8.533-8.533C397.346,230.4,401.169,234.223,401.169,238.933"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M426.769,256c0,4.71-3.823,8.533-8.533,8.533c-4.71,0-8.533-3.823-8.533-8.533 c0-4.71,3.823-8.533,8.533-8.533C422.946,247.467,426.769,251.29,426.769,256"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M418.235,281.6c0,4.71-3.823,8.533-8.533,8.533c-4.71,0-8.533-3.823-8.533-8.533 s3.823-8.533,8.533-8.533C414.412,273.067,418.235,276.89,418.235,281.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M392.635,264.533c0,4.71-3.823,8.533-8.533,8.533c-4.71,0-8.533-3.823-8.533-8.533 c0-4.71,3.823-8.533,8.533-8.533C388.812,256,392.635,259.823,392.635,264.533"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B6BB"
    },
    d: "M290.133,204.8h-51.2c-9.429,0-17.067-7.637-17.067-17.067V153.6 c0-9.429,7.637-17.067,17.067-17.067h51.2c9.429,0,17.067,7.637,17.067,17.067v34.133C307.2,197.163,299.562,204.8,290.133,204.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M273.066,179.2H256c-4.719,0-8.533-3.814-8.533-8.533c0-4.719,3.814-8.533,8.533-8.533h17.067 c4.719,0,8.533,3.814,8.533,8.533C281.6,175.386,277.785,179.2,273.066,179.2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.8e199241148a4eb591ce087feac06219.svg";
export { ForwardRef as ReactComponent };